import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { TableView } from '../../../helpers/tableview';
import { AdminDashboardService } from '../../admin/dashboard/dashboard.service'
import { DevicesService } from "../../admin/devices/devices.service";
import { ToastyService, ToastOptions } from 'ng2-toasty';

@Component({
    selector: 'offline-static-devices',
    template: `
    <div class="device-offline-dlg">
  
        <div class="col-sm-20">
            <div class="page admin page-admin-approval">
                <h2>Devices</h2>
                <div class="table">
                    <table  [ngBusy]="table.updating">
                        <thead>
                            <tr>
                                <th [sort-params]="table.filter" [sortable]="'id'">
                                    ID 
                                    <i class="fa fa-sort-asc" aria-hidden="true"></i>
                                    <i class="fa fa-sort-desc" aria-hidden="true"></i>
                                </th>
                                <th [sort-params]="table.filter" [sortable]="'name'">
                                    Name
                                    <i class="fa fa-sort-asc" aria-hidden="true"></i>
                                    <i class="fa fa-sort-desc" aria-hidden="true"></i>
                                </th>
                                <th [sort-params]="table.filter" [sortable]="'description'">
                                    Description
                                    <i class="fa fa-sort-asc" aria-hidden="true"></i>
                                    <i class="fa fa-sort-desc" aria-hidden="true"></i>
                                </th>
                                <th [sort-params]="table.filter" [sortable]="'approved'">
                                    Approved
                                    <i class="fa fa-sort-asc" aria-hidden="true"></i>
                                    <i class="fa fa-sort-desc" aria-hidden="true"></i>
                                </th>
                                <th [sort-params]="table.filter" [sortable]="'online'">
                                    Online
                                    <i class="fa fa-sort-asc" aria-hidden="true"></i>
                                    <i class="fa fa-sort-desc" aria-hidden="true"></i>
                                </th>
                                <th [sort-params]="table.filter" [sortable]="'city_id'">
                                    City
                                    <i class="fa fa-sort-asc" aria-hidden="true"></i>
                                    <i class="fa fa-sort-desc" aria-hidden="true"></i>
                                </th>    

                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of table.items">
                                <td *ngIf="item.approved" style="width:4em;">{{item.id}}</td>
                                <td *ngIf="item.approved" style="width:4em;">{{item.name}}</td>
                                <td *ngIf="item.approved" class="name" style="width:4em;">{{item.description}}</td>
                                <td *ngIf="item.approved" style="width:4em;">{{item.approved ? "Yes" : ""}}</td>
                                <td *ngIf="item.approved" style="width:4em;">{{item.online ? "Yes" : ""}}</td>
                                <td *ngIf="item.approved" style="width:4em;">{{item.city?.name}}</td>
                                
                                <td *ngIf="item.approved" style="width:4em;">
                                    <button *ngIf="item.can_send_pushes" class="button btn-danger" type="button" (click)="sendPush(item.id)">Restart</button>
                                    <div *ngIf="!item.can_send_pushes" style="color: red;">
                                    No Push!
                                    <i class="inform-icon s-tooltip">
                                        <span class="s-tooltiptext" style="width: 420px;">
                                                "No Push!" means that this device cannot be remotely restarted.<br>
                                                Push token is missing for this device.<br>
                                                A reinstall of the App for this device recommended.
                                        </span>
                                    </i>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
            </div>

            <div class="pagination clearfix">
                <div class="perPage">
                    Show 
                    <select [(ngModel)]="table.filter.perPage" (ngModelChange)="table.setPage(1)">
                        <option *ngFor="let perPage of [10,20,50,100]" [value]="perPage">{{perPage}}</option>
                        <option value=0>All</option>
                    </select>
                </div>

                <div class="pages" *ngIf="table.filter.perPage > 0 && table.total > table.filter.perPage">
                    <ul>
                        <li *ngFor="let page of table.getPages()" (click)="table.setPage(page)" [class.active]="page == table.filter.page">{{page}}</li>
                    </ul>
                </div>

                <div class="showing" *ngIf="table.items.length">
                    {{(table.filter.page-1) * table.filter.perPage + 1}}-{{table.filter.perPage * (table.filter.page-1) + table.items.length}} of {{table.total}}
                </div>
            </div>
          
    </div>`,
    styleUrls:['./offlinedevices.scss'],
    providers:[AdminDashboardService, DevicesService, DevicesService]
  })

export class OfflineStaticDevices implements OnInit {
    public table: TableView;
    public result: any;

    constructor(private adminDashboardService: AdminDashboardService, private adminDevicesService: DevicesService, private toastyService:ToastyService){
    } 

    ngOnInit(){
        this.table = new TableView(filter => this.adminDashboardService.findStaticOfflineDevices(filter));
        this.table.filter.sortBy = "id";
        this.table.filter.sortAsc = false;
        this.table.applyFilter();
        this.table.refreshEvery(60);
    }

    ngOnDestroy(){
        this.table.refreshEvery(0);
    }

    sendPush(deviceID: number) {
        this.adminDevicesService.sendPush(deviceID).then(result => {
          let toastOptions:ToastOptions = {
              title: null,
              msg: "Push sent to device "+deviceID+"!",
              showClose: true,
              timeout: 5000,
              theme: "bootstrap"
          };
          this.toastyService.success(toastOptions);
        }, err => {
          let toastOptions:ToastOptions = {
              title: null,
              msg: err,
              showClose: true,
              timeout: 5000,
              theme: "bootstrap"
          };
          this.toastyService.error(toastOptions);
        });
      }
    
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/admin/dashboard/offlinedevices.ts